import { Div, Collection, CollectionPrinter, Select } from "@tblabs/truffle";
import { Step } from "../../../../Steps/Step/Step";
import { StepFactory } from "../../../../Services/StepFactory";
import { StepType } from "../../../../Steps/Step/StepType";
import { DateTimeProvider } from "../../../../Services/DateTimeProvider";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { AddToBasketStep } from "../../../../Steps/AddToBasket/AddToBasketStep";
import { RawProductFromWebsite } from "../../../../Models/ProductsCatalog/RawProduct";
import { GenericEntryEditBox } from "./GenericEntryEditBox";
import { AddToBasketEntryEditBox } from "./AddToBasketEntryEditBox";
import { PaymentEntryEditBox } from "./PaymentEntryEditBox";
import { PackageToCustomerEntryEditBox } from "./PackageToCustomerEntryEditBox";
import { Switch } from "./Switch";
import { XPrimaryButton } from "../../../../Components/Utils/XPrimaryButton";
import { Icons } from "../../../../Components/Utils/Icons";
import { PackageToCustomerStep } from "../../../../Steps/PackageToCustomer/PackageToCustomerStep";
import { Order } from "../../../../Models/Order";
import { PersonalPickupStep } from "../../../../Steps/PersonalPickup/PersonalPickupStep";
import { PersonalPickupEntryEditBox } from "./PersonalPickupEntryEditBox";
import { PaymentStep } from "../../../../Steps/Payment/PaymentStep";
import { ShopContent } from "../../../../Shop/ShopContent";
import { PaymentReturnStep } from "../../../../Steps/Payment/PaymentReturnStep";


export class StepsEdit extends Div
{
    constructor(private _factory: StepFactory, private _shop: ShopContent, private order: Order)
    {
        super();

        const addStepSelect = new Select(undefined, _factory.StepsLabels)
            .WidthAuto().MarginLeft(8).AddDefaultOption("Wybierz (krok...")
            .OnChange((v, i, k) =>
            {
                this.AddStep(v as StepType);
                addStepSelect.RemoveSelf();
            })

        this.Append(
            new CollectionPrinter(this.order.Steps, x => this.GetEditor(x)).Class("panels-container"),

            new XPrimaryButton("Dodaj krok", Icons.Plus)
                .OnClick(() => this.Append(addStepSelect))
                .MarginTop(16)
        );
    }

    private GetEditor(x: Step<any>) 
    {
        const steps: Collection<Step<any>> = this.order.Steps;

        return new Switch<StepType, appendable>()
            .Case(StepType.AddToBasket, () => new AddToBasketEntryEditBox(x as AddToBasketStep, steps, this._shop))
            .Case(StepType.PackageToCustomer, () => new PackageToCustomerEntryEditBox(x as PackageToCustomerStep, steps))
            .Case(StepType.PersonalPickup, () => new PersonalPickupEntryEditBox(x as PersonalPickupStep, steps))
            .Case(StepType.Payment, () => new PaymentEntryEditBox(x as PaymentStep, steps))
            .Case(StepType.PaymentReturn, () => new PaymentEntryEditBox(x as PaymentReturnStep, steps))
            .Default(() => new GenericEntryEditBox(x, steps))
            .Execute(x.Type)
    }

    private AddStep(step: StepType): void
    {
        const stepInstance = this._factory.Create(step, { CreatedAt: DateTimeProvider.Now });
        stepInstance.Order = this.order;

        this.order.Steps.Add(stepInstance);
    }
}
